
import moment from "moment";
import { translate } from "../Services/translation";
const onhandcheckLanguage = (translateprefix,nextIncomingDate,transilate) => {
    //let language=window.__litium.constants.currentLocale;
    return translate(translateprefix).replace("{0}", moment(new Date(nextIncomingDate)).format("YYYY") + translate(transilate) + moment(new Date(nextIncomingDate)).isoWeeks()) 
  };
  export default onhandcheckLanguage;